(function () {
  const normalizeId = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

  const initializeTableOfContents = (layout) => {
    if (layout.dataset.tocReady === 'true') return;

    const content = layout.querySelector('[data-article-content]');
    const navigations = Array.from(layout.querySelectorAll('[data-article-toc-nav]'));
    const lists = Array.from(layout.querySelectorAll('[data-article-toc-list]'));
    if (!content || navigations.length === 0 || lists.length === 0) return;

    const headings = Array.from(content.querySelectorAll('.article-template__content h2, .article-template__faq-heading'))
      .filter((heading) => heading.textContent.trim().length > 0);

    if (headings.length < 2) {
      layout.dataset.tocReady = 'true';
      return;
    }

    const usedIds = new Set(Array.from(document.querySelectorAll('[id]')).map((element) => element.id));
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const baseId = normalizeId(heading.textContent) || `article-section-${index + 1}`;
        let uniqueId = baseId;
        let suffix = 2;

        while (usedIds.has(uniqueId)) {
          uniqueId = `${baseId}-${suffix}`;
          suffix += 1;
        }

        heading.id = uniqueId;
        usedIds.add(uniqueId);
      }

      lists.forEach((list) => {
        const item = document.createElement('li');
        item.className = 'article-template__toc-item';

        const link = document.createElement('a');
        link.className = 'article-template__toc-link';
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        if (index === 0) link.classList.add('is-active');

        item.appendChild(link);
        list.appendChild(item);
      });
    });

    const links = Array.from(layout.querySelectorAll('.article-template__toc-link'));

    const setActiveLink = (heading) => {
      links.forEach((link) => {
        const isActive = link.getAttribute('href') === `#${heading.id}`;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'location');

          const desktopNavigation = link.closest('.article-template__toc--desktop');
          if (desktopNavigation) {
            const stickyTitle = desktopNavigation.querySelector('.article-template__toc-title');
            const visibleTop = desktopNavigation.scrollTop + (stickyTitle ? stickyTitle.offsetHeight : 0);
            const visibleBottom = desktopNavigation.scrollTop + desktopNavigation.clientHeight;
            const linkTop = link.offsetTop;
            const linkBottom = linkTop + link.offsetHeight;

            if (linkTop < visibleTop) {
              desktopNavigation.scrollTop = Math.max(0, linkTop - (stickyTitle ? stickyTitle.offsetHeight : 0));
            } else if (linkBottom > visibleBottom) {
              desktopNavigation.scrollTop += linkBottom - visibleBottom;
            }
          }
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
          if (visible[0]) setActiveLink(visible[0].target);
        },
        { rootMargin: '-18% 0px -68% 0px', threshold: 0 },
      );

      headings.forEach((heading) => observer.observe(heading));
    }

    links.forEach((link) => {
      link.addEventListener('click', () => {
        const heading = headings.find((item) => link.getAttribute('href') === `#${item.id}`);
        if (heading) setActiveLink(heading);

        const mobileDropdown = link.closest('.article-template__toc-mobile');
        if (mobileDropdown) mobileDropdown.removeAttribute('open');
      });
    });

    navigations.forEach((navigation) => {
      navigation.hidden = false;
    });
    layout.dataset.tocReady = 'true';
  };

  const initializeAllTablesOfContents = (root = document) => {
    root.querySelectorAll('[data-article-toc]').forEach(initializeTableOfContents);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllTablesOfContents());
  } else {
    initializeAllTablesOfContents();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllTablesOfContents(event.target));
})();
